/** 每日登录免费领取积分（接口未返回时的展示默认值） */
export const DEFAULT_DAILY_BONUS_AMOUNT = 20
export const BOOSTED_DAILY_BONUS_AMOUNT = 30
export const BOOSTED_DAILY_BONUS_COUNTRIES = new Set([
  'ID',
  'US',
  'IN',
  'RU',
  'BR',
  'PH',
  'FR',
  'IT',
  'UA',
  'VN',
])

export function resolveDailyBonusFallback(country) {
  const code = String(country || '').trim().toUpperCase()
  return BOOSTED_DAILY_BONUS_COUNTRIES.has(code)
    ? BOOSTED_DAILY_BONUS_AMOUNT
    : DEFAULT_DAILY_BONUS_AMOUNT
}
